export default {
    init() {
        const sectionLinks = $('.ajax-sub-nav a');
        // Set first link to active
        sectionLinks.first().addClass('active-link');
        // Add active to clicked nav items
        sectionLinks.on('click', function () {
            sectionLinks.removeClass('active-link');
            $(this).addClass('active-link');
        });

        const ajaxContent = $('#ajax-content');
        sectionLinks.on('click', function (e) {
            e.preventDefault();
            // Get links href url
            var url = $(this).attr('href');
            // Get the last part of the url (after the last /) and make that the key
            var key = url.match(/\/([^/]+)\/?$/)[1];
            // Add a hash and key to the current URL (only if it's not the first item)
            var hash = ' ';
            if ($(this).attr('href') !== sectionLinks.first().attr('href')) {
                hash = '#' + key;
            }

            history.replaceState(null, null, hash);

            // Fetch section content and add to current page
            $.ajax({
                url: url,
                beforeSend: function () {
                    ajaxContent.addClass('loading');
                },
                complete: function () {
                    ajaxContent.removeClass('loading');
                },
                success: function (data) {
                    data = $.parseHTML(data);
                    // Get custom styles created via page builder
                    const customStyles = $(data).filter(
                        'style[data-type="vc_shortcodes-custom-css"]'
                    );
                    // get the html content we want to use to replace current content
                    const ajaxReplacement = $(data).find('#ajax-content > div');
                    // If there are custom styles, add them to the end of the head
                    if (customStyles) {
                        $('head').append(customStyles);
                    }
                    // Empty current content and replace with fetched content
                    ajaxContent.empty();
                    ajaxContent.html(ajaxReplacement);

                    // This function is taken from WP Bakery Page Builder
                    // It expands out full width rows when loaded in via ajax
                    function fullWidthRow() {
                        var $elements = $('[data-vc-full-width="true"]');
                        $.each($elements, function () {
                            var $el = $(this);
                            $el.addClass('vc_hidden');
                            var $el_full = $el.next('.vc_row-full-width');
                            if (
                                ($el_full.length ||
                                    ($el_full = $el
                                        .parent()
                                        .next('.vc_row-full-width')),
                                $el_full.length)
                            ) {
                                var el_margin_left = parseInt(
                                        $el.css('margin-left'),
                                        10
                                    ),
                                    el_margin_right = parseInt(
                                        $el.css('margin-right'),
                                        10
                                    ),
                                    offset =
                                        0 -
                                        $el_full.offset().left -
                                        el_margin_left,
                                    width = $(window).width();
                                if (
                                    ($el.css({
                                        position: 'relative',
                                        left: offset,
                                        'box-sizing': 'border-box',
                                        width: $(window).width(),
                                    }),
                                    !$el.data('vcStretchContent'))
                                ) {
                                    var padding = -1 * offset;
                                    0 > padding && (padding = 0);
                                    var paddingRight =
                                        width -
                                        padding -
                                        $el_full.width() +
                                        el_margin_left +
                                        el_margin_right;
                                    0 > paddingRight && (paddingRight = 0),
                                        $el.css({
                                            'padding-left': padding + 'px',
                                            'padding-right':
                                                paddingRight + 'px',
                                        });
                                }
                                $el.attr('data-vc-full-width-init', 'true'),
                                    $el.removeClass('vc_hidden'),
                                    $(document).trigger(
                                        'vc-full-width-row-single',
                                        {
                                            el: $el,
                                            offset: offset,
                                            marginLeft: el_margin_left,
                                            marginRight: el_margin_right,
                                            elFull: $el_full,
                                            width: width,
                                        }
                                    );
                            }
                        }),
                            $(document).trigger('vc-full-width-row', $elements);
                    }
                    fullWidthRow();
                },
            });
        });

        // If the page loads with a hash, fetch that section
        if (window.location.hash) {
            let url = '';
            var customStyles, ajaxReplacement;
            // Get just the hash part of the url
            var key = window.location.hash.slice(1);
            // Go through each sub nav links
            $('.ajax-sub-nav a').each(function () {
                // Get it's href url
                var subNavUrl = $(this).attr('href');
                // Get the last part of the url (after the last /)
                var subNavUrlEnd = subNavUrl.match(/\/([^/]+)\/?$/)[1];
                // If this matches the hash (key), set this url to the url we will use to fetch content via AJAX
                if (subNavUrlEnd === key) {
                    url = subNavUrl;
                }
            });

            // If we have a valid url
            if (url.length) {
                // Go getch the content via AJAX
                $.ajax({
                    url: url,
                    success: function (data) {
                        data = $.parseHTML(data);
                        // Get custom styles created via page builder
                        customStyles = $(data).filter(
                            'style[data-type="vc_shortcodes-custom-css"]'
                        );
                        // get the html content we want to use to replace current content
                        ajaxReplacement = $(data).find('#ajax-content > div');
                        // If there are custom styles, add them to the end of the head
                        if (customStyles) {
                            $('head').append(customStyles);
                        }
                        // Empty current content and replace with fetched content
                        ajaxContent.empty();
                        ajaxContent.html(ajaxReplacement);
                    },
                });
            }
        }
    },
    finalize() {
        function subNavTemplateResize() {
            let viewportWidth = $(window).width();
            let containerWidth;
            if (viewportWidth >= 1440) {
                containerWidth = 1280;
            } else if (viewportWidth < 768) {
                containerWidth = viewportWidth;
            } else {
                containerWidth = viewportWidth - 160;
            }
            let spacer;
            let subNavIntro = $('#sub-nav-intro');
            let subNavIntroInnerColumn = $(
                '#sub-nav-intro-inner-column > .vc_column-inner > .wpb_wrapper'
            );

            if (containerWidth) {
                spacer = (viewportWidth - containerWidth) / 2;

                subNavIntro.css({
                    'padding-left': spacer + 'px',
                });

                subNavIntroInnerColumn.css({
                    'padding-right': spacer + 'px',
                });

                if (viewportWidth < 768) {
                    subNavIntro.css({
                        'padding-right': spacer + 'px',
                    });
                }
            }
        }

        subNavTemplateResize();

        $(window).resize(subNavTemplateResize);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSubNav.js